import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import styles from './rb-uploading-modal.css';

const RbUploadingModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={props.uploadModalType === 'burning' ? 'Uploading...' : 'Updating Firmware'}
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <Box className={styles.flexWrapper}>
                <Box className={styles.editorWrapper}>
                    <div className={styles.progress}>
                        <span className={styles.progressVal}>{props.percent}{'%'}</span>
                        <span className={styles.progressBar}>
                            <span
                                className={styles.progressIn}
                                style={{width: `${props.percent}%`}}
                            />
                        </span>
                    </div>
                </Box>
            </Box>
        </Box>
    </Modal>
);

RbUploadingModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    percent: PropTypes.number.isRequired,
    uploadModalType: PropTypes.string
};

export default RbUploadingModal;
